import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { serializeSignReceiptCreate } from './serialize';

/**
 * POST `/aftersales/sign-receipt` → 201。
 * body：`signReceiptNo`＋`repairItemIds`＋選填 header 快照。
 */
export async function createSignReceipt(payload) {
  const { data: raw } = await request.post(
    '/aftersales/sign-receipt',
    serializeSignReceiptCreate(payload),
  );
  return parseVer4DetailResponse(raw);
}
